import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectFileUploading } from '@/store/slices/ReportsSlice'
import LogoSection from '@/shared/components/LogoSection'
import DesktopActions from '@/shared/components/DesktopActions'
import MobileMenu from '@/shared/components/MobileMenu'

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [menuClicked, setMenuClicked] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [addTokenOpen, setAddTokenOpen] = useState(false)
  const uploading = useSelector(selectFileUploading)

  const handleLogoClick = (dest) => {
    if (!uploading) {
      if (dest === 'home') {
        navigate('/')
      }
      else if (dest === 'tool') {
        navigate(`/${location.pathname.split('/')[1]}`)
      }
    }
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false);
        setMenuClicked(false);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={`relative`}>
      <div className={`relative z-0 mt-5 sm:mt-[20px] mb-[4px] h-[60px] px-5 py-4 w-[90vw] md:w-[80vw] bg-white border border-[#E4E4E7] header-shadow flex justify-between gap-[4px] items-center md:rounded-[20px] sm: ${menuClicked ? 'rounded-t-[20px] rounded-b-[4px] z-20' : 'rounded-[20px]'}`}>
        <LogoSection 
          uploading={uploading} 
          onLogoClick={handleLogoClick} 
        />
        
        <DesktopActions 
          addTokenOpen={addTokenOpen}
          setAddTokenOpen={setAddTokenOpen}
        />

        <MobileMenu 
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
          addTokenOpen={addTokenOpen}
          setAddTokenOpen={setAddTokenOpen}
        />
      </div>
    </div>
  )
}

export default Header
